import axios from 'axios';
import { URLS } from '@wix/da-url';
import { all, call, put, select, takeEvery } from 'redux-saga/effects';
import {
  getCsrfToken,
  getCurrentUser,
} from '@wix/da-shared-react/pkg/publicSession/selectors';
import { uploadAvatar } from '../actions/avatar';
import { normalize } from '@wix/da-shared-react/pkg/redux/normalizr';
import { userSchema } from '@wix/da-shared-react/pkg/redux/normalizr/schemas/user';

const DAPI_ROOT = (() => {
  let url = `${URLS.ROOT}/dapi/v1/dauserprofile`;
  if (process.env.NODE_ENV !== 'production') {
    url = url.replace('.com', '.lan');
  }
  return url;
})();

function dapiPost(endpoint, data, options) {
  if (process.env.NODE_ENV !== 'production') {
    return Promise.resolve({ content: true });
  }
  return axios
    .request({
      method: 'post',
      baseURL: DAPI_ROOT,
      url: `/${endpoint}`,
      ...options,
      data,
    })
    .then(response => {
      return response.data;
    })
    .catch(error => {
      return false;
    });
}

export function* uploadAvatarSaga(action) {
  const { payload } = action;

  const options = {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    withCredentials: true,
  };
  const formData = new FormData();
  formData.append('file', payload.file, payload.filename);
  formData.append('_csrf', yield select(getCsrfToken));
  const response = yield call(dapiPost, 'avatar/set', formData, options);
  if (response && response.content) {
    const usericon = yield call(file2base64, payload.file);
    yield call(updateUserAvatar, usericon);
  }
}

const file2base64 = file =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result);
    reader.readAsDataURL(file);
  });

function* updateUserAvatar(usericon) {
  const currentUser = yield select(getCurrentUser);
  const normalizedData = normalize({ ...currentUser, usericon }, userSchema);
  yield put({ type: 'TRIGGER.NORMALIZR.UPDATE', ...normalizedData });
}

export function* updateUserAvatarSaga(action) {
  const { payload } = action;
  const { usericon } = payload;
  yield call(updateUserAvatar, usericon);
}

export default function* rootAvatarSaga() {
  yield all([takeEvery(uploadAvatar, uploadAvatarSaga)]);
}
